import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import config from 'config'
import ROCKET_IMG from 'images/rocket.svg'
import SuccessLander from 'components/SuccessLander'
import { getPlanDisplayName } from 'modules/billing/selectors'
import { DefaultPlanName } from 'constants/dealConstants'

const BUTTON_TEXT = 'Go to my dashboard'
class DealLinkSuccessStep extends Component {
  render() {
    const { planName } = this.props
    const abbreviatedPlanName = (planName === DefaultPlanName ? planName : planName.split(' ')[0])
    const HEADER_TEXT = `Welcome to ${abbreviatedPlanName}`
    const SUBHEADER_TEXT = (planName === DefaultPlanName) ? `You’ve successfully upgraded.` : `You’ve successfully upgraded to the ${planName}.`
    return (
      <Fragment>
        <SuccessLander
          image={ROCKET_IMG}
          headerText={HEADER_TEXT}
          buttonText={BUTTON_TEXT}
          onButtonClick={() => {
            window.location.replace(config.CUSTOMER_WEB_URL)
          }}
          subheaderText={SUBHEADER_TEXT} />
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    planName: getPlanDisplayName(state),
  }
}

export default connect(mapStateToProps)(DealLinkSuccessStep)


// WEBPACK FOOTER //
// ./src/layouts/DealUpgradeSuccessStep/index.js